import { createFileRoute } from '@tanstack/react-router';
import { CRMClientsPage } from '@/pages/CRM/Clients';

export const Route = createFileRoute('/_admin/crm/clients/')({
  component: CRMClientsPage,
});
